/** Why the viewer can't unstack, shown on the inactive "Unstack pull requests" menu item. */
export function getUnstackInactiveText({
  viewerCanUnstack,
  allPullsLocked,
}: {
  viewerCanUnstack: boolean | undefined
  allPullsLocked: boolean | undefined
}) {
  if (!viewerCanUnstack) return "You don't have permission"
  if (allPullsLocked) return 'This stack cannot be unstacked'
  return undefined
}
